import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable'
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {JwtHelper, tokenNotExpired} from 'angular2-jwt';
import {User} from '../domain/user';
import {Http, Headers, RequestOptions, Request, RequestMethod, Response, BaseRequestOptions} from '@angular/http';
import {Router} from '@angular/router';
import { environment } from 'environments/environment';
import {GlobalAppService} from '../commons/global-app.service';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/fromPromise'
import 'rxjs/add/observable/of'
import {MessageSeverity} from '../commons/message-severity';


@Injectable()
export class AuthService {

    private _base_url: string = environment.backendHost;
    private _refresh_url = '/refresh';
    private _auth_url = '/auth';
    private jwtHelper: JwtHelper = new JwtHelper();
    private _user: BehaviorSubject<User> = new BehaviorSubject<User>(null);
    private $user: Observable<User>;

    constructor( private _http: Http,
                private router: Router,
                private appService: GlobalAppService) {}

    get user(): Observable<User> {
        return this._user.asObservable().filter(user => user != null);
    }

    get user_value(): User {
        return this._user.getValue();
    }

    get base_url(): string {
        return this._base_url;
    }

    get refresh_url(): string {
        return this._refresh_url;
    }

    get auth_url(): string {
        return this._auth_url;
    }

    get http(): Http {
        return this._http;
    }

    public login(username, password): Observable<any> {
        const body = JSON.stringify({
            'username': username,
            'password': password
        });
        const headers = new Headers({'Content-Type': 'application/json'});
        const options = new RequestOptions({headers: headers});

        return this._http.post(this.base_url + this.auth_url, body, options)
            .map(res => res.json())
            .do(res => {
                const token = res.token;
                localStorage.setItem(environment.tokenName, token);
                this.setUserIn();
            });
    }

    public logout() {
        this._user.next(null);
        localStorage.removeItem(environment.tokenName);
        // this._user.next(null);
        return this.router.navigate(['login']);
    }

    // TODO: servicio aún no implementado en el API
    public refreshToken(): Observable<any> {
        const reqOptions = new BaseRequestOptions();
        return this._http.get(this.base_url + this.refresh_url, this.addToken(reqOptions))
            .map(res => res.json().token)
            .do(token => {
                    localStorage.setItem(environment.tokenName, token);
                    console.log('Token refreshed : ' + this.jwtHelper.decodeToken(token))
                }
            );
    }

    private addToken(req: RequestOptions): RequestOptions {
        req.headers.append('Authorization', localStorage.getItem(environment.tokenName));
        return req;
    }

    public authRequest(url: string, reqOptions: RequestOptions): Observable<Response> {
        const token = localStorage.getItem(environment.tokenName);
        if (!token) {
            this.router.navigate(['login']).then(console.log).catch(console.log);
            this.appService.setLoading(false);
            // return new EmptyObservable();
            return Observable.throw(new Error('Unauthenticated'));
        }else if (this.jwtHelper.isTokenExpired(token)) {
            return Observable.fromPromise(this.logout())
                .do(() => this.appService.setLoading(false))
            //  .switchMap(() => new EmptyObservable());
                .switchMap(() => Observable.throw(new Error('ExpiredToken')))

            /*
            this.refreshToken().subscribe(function (r: any) {
                return this._http.request(url, this.addToken(reqOptions));
            });
            */
        }else {
            return this._http.request(url, this.addToken(reqOptions))
                .catch(err => {
                    if (err.status === 406) {
                        this.appService.sendMsg(
                            MessageSeverity.ERROR,
                            'Recurso no encontrado',
                            'Error al procesar el reporte. ')
                        this.appService.setLoading(false);
                    }
                    if (err.status === 403) {
                        this.appService.sendMsg(
                            MessageSeverity.ERROR,
                            'Permisos Insuficientes',
                            'Usted no posee los permisos necesarios para realizar la action solicitada. ' +
                            'Si desea contar con dichos permisos pongase en contacto con el administrador del sistema.')
                        this.appService.setLoading(false);
                    }
                    return Observable.throw(err);
                });
        }
    }

    public publicRequest(url: string, reqOptions: RequestOptions): Observable<Response>{
        return this._http.request(url, reqOptions);
    }

    public isLoggedIn(): boolean {
        const token = localStorage.getItem(environment.tokenName);
        return (token !== null && !this.jwtHelper.isTokenExpired(token))
    }

    // TODO: Si el usuario ya esta seteado en el servicio, no tengo que volver a recuperarlo de la base.
    public setUserIn() {
        const reqOptions = new BaseRequestOptions();
        reqOptions.method = RequestMethod.Get;
        this.authRequest(environment.backendHost + '/user', reqOptions)
            .map(res => new User(res.json()))
            .subscribe(user => this._user.next(user));
    }
}





// WEBPACK FOOTER //
// ./src/app/core/security/auth.service.ts